module.exports = __webpack_public_path__ + "static/a-parto-agendado-fd5936bf8f9360f851a0edb993b6c548.jpg";